/* import __COLOCATED_TEMPLATE__ from './revision.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();